<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link :to="{ name: 'EXSBPriceGroupCreate' }" class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
            </b-col>
          </b-row>
          <!--<div v-if="isLoading" class="alert alert-info">{{$t('alerts.loading')}}...</div>-->
          <div v-if="deletedItem" class="alert alert-success">{{ deletedItem['name'] }} {{$t('notifications.deleted')}}</div>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <Loader v-if="isLoading" size="lg"></Loader>
              <template v-else>
                <b-row>
                  <b-col>
                    <div v-if="items.length > 0">
                      <table class="table table-sm table-striped table-hover">
                        <thead>
                        <tr>
                          <th>{{$t('views.exsbitemscategories.list.name')}}</th>
                          <th>{{$t('views.exsbitemscategories.list.description')}}</th>
                          <th colspan="1" />
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in items" :key="item['@id']">
                          <td>
                            {{ item['name']}}
                          </td>
                          <td>
                            {{ item['description'] }}
                          </td>
                          <td>
                            <router-link :to="{name: 'EXSBPriceGroupUpdate', params: { id: item['@id'] }}" class="float-right">
                              <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                            </router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <p v-else>{{$t('views.exsbitemscategories.list.noItemsCategories')}}</p>
                  </b-col>
                </b-row>
                <div v-if="view">
                  <pagination
                    :view="view"
                    @getPage="getPage($event)"
                  ></pagination>
                </div>
              </template>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },

  computed: mapGetters({
    deletedItem: 'exsbpricegroup/del/deleted',
    error: 'exsbpricegroup/list/error',
    items: 'exsbpricegroup/list/items',
    isLoading: 'exsbpricegroup/list/isLoading',
    view: 'exsbpricegroup/list/view'
  }),

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBPriceGroupList')
  },

  created () {
    this.getPage()
    this.channelBusinessPriceGroups = this.$store.state.Pusher.subscribe('e_x_s_b_price_groups')
    this.channelBusinessPriceGroups.bind('e_x_s_b_price_groups', data => {
      this.getPage()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_price_groups')
  },

  methods: mapActions({
    getPage: 'exsbpricegroup/list/default'
  })
}
</script>
